/**
 * CARTO raster basemap tile URL for Leaflet.
 * Appends `?key=` per https://docs.carto.com/faqs/carto-basemaps when a key is
 * present at build time. Never log or echo the key value.
 */

const LIGHT_ALL = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";

export const CARTO_BASEMAP_ATTRIBUTION = "© OpenStreetMap · © CARTO";

export const CARTO_BASEMAP_LAYER_OPTIONS = {
  attribution: CARTO_BASEMAP_ATTRIBUTION,
  maxZoom: 19,
  subdomains: "abcd",
};

/**
 * Resolve the public basemap key from:
 * 1) optional runtime inject `window.__IZISELL_CARTO_BASEMAP_KEY__` (basemap-runtime.js)
 * 2) build-time env (CRA embeds REACT_APP_*; Vercel VITE_CARTO_BASEMAP_KEY is bridged in craco)
 * Never log the key value.
 */
function basemapKey() {
  const runtime =
    typeof window !== "undefined" && window.__IZISELL_CARTO_BASEMAP_KEY__
      ? window.__IZISELL_CARTO_BASEMAP_KEY__
      : "";
  const raw =
    runtime ||
    process.env.REACT_APP_CARTO_BASEMAP_KEY ||
    process.env.VITE_CARTO_BASEMAP_KEY ||
    "";
  return typeof raw === "string" ? raw.trim() : "";
}

/** Leaflet tile URL template for CARTO Positron (light_all), with key when configured. */
export function cartoLightAllTileUrl() {
  const key = basemapKey();
  if (!key) return LIGHT_ALL;
  return `${LIGHT_ALL}?key=${encodeURIComponent(key)}`;
}

export function cartoBasemapConfigured() {
  return Boolean(basemapKey());
}
